import { render, staticRenderFns } from "./deliverability.vue?vue&type=template&id=52dd1a51&scoped=true&"
import script from "./deliverability.vue?vue&type=script&lang=js&"
export * from "./deliverability.vue?vue&type=script&lang=js&"
import style0 from "./deliverability.vue?vue&type=style&index=0&id=52dd1a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd1a51",
  null
  
)

export default component.exports